import { FinchProviderKey } from '@common/neo.tax';

import { PayrollProvider } from '@neo.tax/shared/graphql';

import { FinchProvider } from './finch.types';

export const FINCH_PROVIDERS: Record<FinchProvider, FinchProviderKey> = {
  [PayrollProvider.Justworks]: 'justworks',
  [PayrollProvider.Trinet]: 'trinet',
  [PayrollProvider.Quickbooks]: 'quickbooks',
  [PayrollProvider.AdpRun]: 'adp_run',
  [PayrollProvider.AdpWorkforceNow]: 'adp_workforce_now',
  [PayrollProvider.CeridianDayforce]: 'ceridian_dayforce',
  [PayrollProvider.PaychexFlex]: 'paychex_flex',
  [PayrollProvider.Paylocity]: 'paylocity',
  [PayrollProvider.Workday]: 'workday',
  [PayrollProvider.Zenefits]: 'zenefits',
};
